import * as React from 'react';
import { Icon } from 'antd';

const ManualSearchCollapsedFilterSvg = props => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M20.3999 19.5L5.3999 4.5M10.1999 10.4416C9.82648 10.8533 9.5999 11.394 9.5999 11.9863C9.5999 13.2761 10.6744 14.3217 11.9999 14.3217C12.611 14.3217 13.1688 14.0994 13.5926 13.7334M20.4387 14.3217C21.2649 13.0848 21.5999 12.0761 21.5999 12.0761C21.5999 12.0761 19.4153 5.1 11.9999 5.1C11.5836 5.1 11.1838 5.12199 10.7999 5.16349M17.3999 17.3494C16.0225 18.2281 14.2492 18.8495 11.9999 18.8127C4.67683 18.693 2.3999 12.0761 2.3999 12.0761C2.3999 12.0761 3.45776 8.69808 6.5999 6.64332"
      stroke="#83878C"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);
const ManualSearchCollapsedFilterIconV2 = props => (
  <Icon component={customProps => <ManualSearchCollapsedFilterSvg {...props} {...customProps} />} {...props} />
);
export default ManualSearchCollapsedFilterIconV2;
